import { Section } from 'components/section'
import { ContactsContainer } from './styled'
import BottomNav from '../layout/bottom-nav'
const ContactInfo = () => {
  return (
    <Section style={{ position: 'relative' }}>
      <Section containerType="textPlusPadding">
        <ContactsContainer>
          Если вы или ваши близкие столкнулись с гендерным насилием, по{' '}
          <a
            href="https://www.currenttime.tv/a/vy-stolknulis-s-domashnim-nasiliem-kuda-obraschatsya-v-stranah-baltii-vostochnoy-evropy-kavkaza-i-tsentralnoy-azii/33315042.html"
            target="_blank"
            rel="noreferrer"
          >
            этой ссылке
          </a>{' '}
          вы можете найти список организаций, которые оказывают помощь в странах
          Центральной Азии, Кавказа, Балтии и Восточной Европы
        </ContactsContainer>
      </Section>
      <BottomNav />
    </Section>
  )
}
export default ContactInfo
